import React from 'react';
import PropTypes from 'prop-types';
import IconPriceTag from '@spothero/icons/price-tag';

export const BenefitMessage = ({percentLowerPrice, iataCode}) => {
    return (
        <div className="BenefitMessage">
            <span className="BenefitMessage-text">
                <IconPriceTag className="BenefitMessage-icon" /> Price is lower
                than {percentLowerPrice}% of {iataCode} spots on SpotHero
            </span>
        </div>
    );
};

BenefitMessage.propTypes = {
    percentLowerPrice: PropTypes.number,
    iataCode: PropTypes.string.isRequired,
};

export default BenefitMessage;
